import { createFileRoute } from "@tanstack/react-router";

import { FeaturePage } from "@/components/site/FeaturePage";
import { featurePage } from "@/content/features";
import { normalizeLocale } from "@/lib/i18n";
import { pageHead } from "@/content/seo-pages";
import { faqScript } from "@/lib/faq-schema";

export const Route = createFileRoute("/{-$locale}/technical-data")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const seo = featurePage("technical-data").seo;
    const head = pageHead("/technical-data", locale, { title: seo.title, description: seo.description });
    return { ...head, scripts: faqScript(featurePage("technical-data").faq, locale) };
  },
  component: technical_dataPage,
});

function technical_dataPage() {
  return <FeaturePage content={featurePage("technical-data")} />;
}
